export default __webpack_public_path__ + "static/barfplan-blog-promo@1x-5a886cb718483a58865ea3ea5d10fa13.png";